import "../../styles/TextFieldWithImage.css"; // Custom CSS file for styling

import React from "react";
import { useState } from "react";

const TextFieldWithImage = ({
	placeholder,
	src,
	padding,
	validate,
	errorMessage,
	width = "100%", // Default width is 100%,
	type = "text",
	value: externalValue,
	onChange: externalOnChange,
	onValidation,
}) => {
	const [internalValue, setInternalValue] = useState("");
	const [error, setError] = useState("");

	const value = externalValue !== undefined ? externalValue : internalValue;

	const handleChange = (e) => {
		const inputValue = e.target.value;
		if (externalOnChange) {
			externalOnChange(inputValue);
		} else {
			setInternalValue(inputValue);
		}
		if (validate) {
			const validationError = validate(inputValue);
			setError(validationError);
			if (onValidation) {
				onValidation(!validationError);
			}
		}
	};

	const handleBlur = () => {
		if (validate) {
			setError(validate(value));
		}
	};

	return (
		<div style={{ marginBottom: "5px", marginTop: "5px", width: width }}>
			<div className='textfield-container'>
				{src && <img src={src} alt='icon' className='text-field-icon' />}
				<input
					type={type}
					value={value}
					onChange={handleChange}
					onBlur={handleBlur}
					placeholder={placeholder}
					className='custom-textfield'
				/>
			</div>
			{error && (
				<div
					style={{
						display: "flex",
						justifyContent: "start",
						marginLeft: "10px",
						marginTop: "2px",
						textAlign: "start",
					}}>
					<span style={{ color: "red", fontSize: "14px" }}>{error}</span>
				</div>
			)}
		</div>
	);
};

export default TextFieldWithImage;
